<script setup lang="ts">
  import { RadioButton, Text, IconChevronDown } from "@ui-kit";

  const {
    is_selected,
    title,
    subtitle,
    is_button_visible = true,
  } = defineProps<{
    is_selected: boolean;
    title: string;
    subtitle?: string;
    is_button_visible?: boolean;
  }>();
  const emit = defineEmits<{ (e: "click:item"): void; (e: "click:btn"): void }>();
</script>

<template>
  <div class="moneymap__filter-range-item">
    <div class="moneymap__filter-range-item__radio" @click="emit('click:item')">
      <RadioButton value="today" :is-checked="is_selected" />
      <div class="moneymap__filter-range-item__details">
        <Text>{{ title }}</Text>
        <Text font="body-regular-14" color="secondary">{{ subtitle }}</Text>
      </div>
    </div>
    <button
      v-if="is_button_visible"
      class="moneymap__filter-range-item__btn"
      data-testid="moneymap-filter-range-item-btn"
      @click="emit('click:btn')"
    >
      <IconChevronDown />
    </button>
  </div>
</template>

<style scoped>
  .moneymap__filter-range-item {
    display: flex;
    gap: 4px;
  }

  .moneymap__filter-range-item__radio {
    display: flex;
    gap: 8px;
    flex: 1;
    padding: 12px 16px;
    border-radius: 12px;
    background-color: var(--sf-base-background-primary);
  }

  .moneymap__filter-range-item__details {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .moneymap__filter-range-item__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    background-color: var(--sf-base-background-primary);
    border-radius: 12px;
  }
</style>
